export interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

export interface FAQCategory {
  type: string;
  data: FAQItem[];
}

export type FAQData = FAQCategory[];

export const faqData: FAQData = [
  {
    type: "신청",
    data: [
      {
        id: 1,
        question: "체험단 신청은 어떻게 하나요?",
        answer:
          "캠페인 모집 페이지에서 원하는 캠페인을 선택 후 신청 버튼을 눌러 정보를 입력하시면 됩니다.",
      },
      {
        id: 2,
        question: "신청 후 변경이나 취소가 가능한가요?",
        answer:
          "•선정 전: 마이페이지 > 신청한 캠페인에서 직접 취소 가능\n•선정 후: 마이페이지 > 취소요청 > 사유와 함께 업체와 소통한 캡처본을 남겨주셔야 하며 캡처본이 없을 경우 승인이 되지않습니다. 개인 사유시 페널티가 부과될 수 있습니다.",
      },
      {
        id: 3,
        question: "신청한 계정을 변경하고 싶어요.",
        answer:
          "신청 시 입력한 계정 외 다른 계정으로 변경은 불가합니다. 반드시 해당 계정으로 체험 및 리뷰를 작성해 주세요.",
      },
      {
        id: 4,
        question: "선정 이력이 있는 캠페인에 재 신청해도 되나요?",
        answer:
          "선정 후 체험 3개월 이후, 재 신청은 가능하나 재 선정 가능 여부는 확답을 드릴 수 없습니다.",
      },
    ],
  },
  {
    type: "선정",
    data: [
      {
        id: 5,
        question: "체험단 선정 기준은 무엇인가요?",
        answer:
          "계정 활성도, 콘텐츠 품질, 최근 활동 내역, 캠페인 적합성 등을 종합적으로 평가하여 선정합니다.",
      },
      {
        id: 6,
        question: "선정 결과는 언제, 어떻게 알 수 있나요?",
        answer:
          "마이페이지 > 나의 캠페인 > 선정된 캠페인에서 확인 가능하며, 카카오톡 알림톡으로 개별 안내됩니다.",
      },
      {
        id: 7,
        question: "선정 후 가이드라인이 있나요?",
        answer:
          "네, 선정자에게는 카카오톡 알림톡으로 리뷰 가이드, 예약 방법, 등록 방법 등 상세 안내가 담긴 가이드라인이 제공됩니다. 가이드라인은 선정된 캠페인에서도 확인 가능합니다.",
      },
      {
        id: 8,
        question: "선정이 안 되면 연락이 오지 않나요?",
        answer:
          "네, 선정자에게만 개별 안내가 발송 되며, 미 선정자에게는 별도 연락이 없습니다.",
      },
      {
        id: 9,
        question: "선정 후 대리인 체험 가능한가요?",
        answer:
          "대리인 체험 가능 캠페인이라고 모집공고가 올라간 경우를 제외하고 기본적으로 대리체험은 불가능 합니다.",
      },
    ],
  },
  {
    type: "예약",
    data: [
      {
        id: 10,
        question: "방문 체험단은 예약이 필수인가요?",
        answer:
          "네, 대부분 캠페인은 사전 예약이 필수이며, 가이드라인에 따라 업체와 직접 예약을 진행 하셔야 합니다.",
      },
      {
        id: 11,
        question: "예약은 어떻게 하나요?",
        answer:
          "선정 후 제공된 연락처로 문자 또는 전화로 직접 예약하시면 됩니다.\n예시: \"안녕하세요, 위유 체험단 선정된 ○○○입니다. ○월 ○일 ○시 예약 가능 할까요?\"",
      },
      {
        id: 12,
        question: "예약 날짜 변경이 가능한가요?",
        answer:
          "업체와 협의하에 변경 가능하며, 리뷰 종료일 이후 체험 시에는 기간연장 요청을 해주셔야 패널티가 부과되지 않으며 기간 연장시 문자 소통 캡처본 제출이 필요합니다.",
      },
      {
        id: 13,
        question: "예약조율이 어려워요.",
        answer:
          "모집 공고와 예약 가능 시간이 업체측에서 상이할 경우(100% 예약제 업종의 경우 늦은 예약으로 예약마감이 된 경우 제외) 혹은 업체 측 연락두절로 예약이 어려운 경우, 리뷰 종료일 이전에 취소 요청을 해주셔야 패널티가 부과되지 않으며 업체와 예약 조율 문자 소통 캡처본 제출이 필요합니다. (개인사정으로 조율이 어려운경우는 제외)",
      },
      {
        id: 14,
        question: "초대권을 실수로 눌러버렸어요.",
        answer:
          "초대권은 현장 방문 후 사용해주셔야 하며, 실수로 사용시 업체측에 선정 되신 번호로 예약 후 말씀해주시면 됩니다.",
      },
    ],
  },
  {
    type: "등록",
    data: [
      {
        id: 15,
        question: "초대권은 꼭 사용해야 하나요?",
        answer:
          "업체 방문시 초대권 사용을 꼭 해주세요. 마이페이지 > 나의 캠페인.> 선정된 캠페인 > 초대권사용을 해주셔야만 리뷰등록이 가능합니다.",
      },
      {
        id: 16,
        question: "리뷰는 어디서 등록하나요?",
        answer:
          "마이페이지 > 나의 캠페인 > 선정된 캠페인 > 초대권사용 > 리뷰등록 > 리뷰등록하기 (리뷰배너 & 리뷰링크 삽입 후 등록하기) > 등록하실 수 있습니다.",
      },
      {
        id: 17,
        question: "등록 시 반드시 포함해야 할 항목은 무엇인가요?",
        answer:
          "아래 항목은 모두 필수입니다. 누락 시 등록이 불가하거나 패널티가 부과될 수 있습니다.\n\n1. 위유 배너 이미지 삽입 (최상단)\n2. 캠페인별 필수 키워드 & 해시태그 포함\n3. 리뷰어 미션의 필수 내용 포함\n   ※ 배너 미등록 시 리뷰 등록이 불가하며, 필수 문구 누락 시 패널티가 적용됩니다.",
      },
      {
        id: 18,
        question: "블로그 외에 릴스/클립도 올려야 하나요?",
        answer:
          "위유 체험단의 모든 캠페인은 블로그 + 네이버 클립 동시 업로드 캠페인입니다. 인스타그램 릴스는 필수가 아닌 권장사항입니다. 모집 공고 가이드라인을 반드시 확인해주세요.",
      },
      {
        id: 19,
        question: "협찬 배너를 꼭 올려야 하나요?",
        answer:
          "협찬배너는 공정위 문구와 동일한 효력을 가지며, 필수사항으로 배너 미 등록시 리뷰등록이 불가합니다.",
      },
      {
        id: 20,
        question: "배너 등록 방법을 모르겠어요.",
        answer:
          "https://weu.kr/review-guide-register 가이드를 보고 천천히 따라해주세요.",
      },
    ],
  },
  {
    type: "마감",
    data: [
      {
        id: 21,
        question: "리뷰 마감일은 어떻게 확인하나요?",
        answer:
          "발표일 기준 3주 이내가 일반적이며, 캠페인별 안내된 마감 기한을 반드시 지켜주세요.\n선정 시 제공되는 가이드라인, 모집 공고 및 마이페이지에서 확인 가능합니다.",
      },
      {
        id: 22,
        question: "조기 마감될 수도 있나요?",
        answer:
          "네, 업체 사정 또는 품질 기준에 따라 리뷰 비공개 요청 또는 조기 마감될 수 있습니다.",
      },
      {
        id: 23,
        question: "마감일 이후 등록하면 어떻게 되나요?",
        answer:
          "업체와 협의 된 경우 기간연장 신청해주시면 패널티가 부여되지 않으며, 마감일 이후 등록시 패널티가 부여 됩니다.\n• 마감일 이후 1일~ 7일이내: 패널티 부여\n• 리뷰 종료일 7일 이후 등록 시: 법적 조치 및 내용증명 발송 절차가 진행될 수 있습니다.",
      },
      {
        id: 24,
        question: "마감일 이후 선정됐던 캠페인 기간연장 가능한가요?",
        answer:
          "캠페인 리뷰종료일 이후에는 캠페인이 끝났기 때문에 기간연장이 불가능합니다. 다음 캠페인 모집에 지원해주세요.",
      },
    ],
  },
  {
    type: "연장",
    data: [
      {
        id: 25,
        question: "체험 기간이나 리뷰 기간 연장은 어떻게 하나요?",
        answer:
          "업체와 협의 된 경우 기간연장 요청해주시면 됩니다. 사전에 협의되지 않은 연장은 절대 불가합니다.",
      },
      {
        id: 26,
        question: "연장 요청은 어디로 하나요?",
        answer:
          "업체와 문자로 조율한 내용을 캡처한 후, 카카오톡 채널 > 기간연장 양식을 작성해서 캡처본과 함께 요청하시면 됩니다.",
      },
      {
        id: 27,
        question: "연장 시 불이익이 있나요?",
        answer:
          "업체와 협의 된 연장은 무관하며, 사전 승인 없이 무단 연장 시 활동 제한 또는 참여 불가 등의 불이익이 발생할 수 있습니다.",
      },
      {
        id: 28,
        question: "기간연장시 리뷰등록은 언제까지 해야하나요?",
        answer:
          "기본적으로 기간연장시 체험일로부터 3일이내 리뷰등록 완료해주셔야하며, 업체와 리뷰등록 마감일을 따로 협의 후 지정하신경우 문자 캡처본 첨부 필수입니다.",
      },
    ],
  },
  {
    type: "취소",
    data: [
      {
        id: 29,
        question: "선정 후 캠페인 취소는 어떻게 하나요?",
        answer:
          "마이페이지 > 나의 캠페인.> 선정된 캠페인 > 취소요청 > 취소사유를 자세히 남겨주시면 확인 후 승인 해드립니다.\n※ 개인 사유인지, 업체 사유인지 명확히 기재해 주세요.\n※ 개인 사유인 경우 패널티가 부여됩니다. 업체 사유인 경우 문자 캡처본 첨부 필수입니다.",
      },
      {
        id: 30,
        question: "단순 변심이나 개인사정으로 취소 해도 되나요?",
        answer:
          "가능하나, 사유가 불분명하거나 반복될 경우 페널티가 부과될 수 있습니다.",
      },
      {
        id: 31,
        question: "자동으로 취소되는 경우가 있나요?",
        answer:
          "예약 미 진행, 연락 두절, 리뷰 미 등록 등의 사유로 운영 기준에 따라 자동 취소될 수 있습니다.",
      },
      {
        id: 32,
        question: "취소 시 금액이 발생하는 경우가 있나요?",
        answer:
          "체험 제공 외 옵션 선택 시 발생하는 추가 비용은 개인 부담이며, 숙박 업소나 100% 예약제 체험의 경우, 당일 취소 밀 미 방문시 체험 비용이 청구될 수 있습니다.",
      },
      {
        id: 33,
        question: "취소 철회도 가능한가요?",
        answer:
          "취소 승인 전 고객센터로 1:1 문의를 주시면 가능하나, 취소처리 승인이후에는 철회가 불가능 합니다. 신중하게 취소 요청 부탁드립니다.",
      },
    ],
  },
  {
    type: "회원정보",
    data: [
      {
        id: 34,
        question: "회원정보 수정은 어디서 하나요?",
        answer: "마이페이지 > 프로필 수정에서 수정 가능합니다.",
      },
      {
        id: 35,
        question: "개인정보는 안전하게 관리되나요?",
        answer:
          "네, 개인정보는 관련 법령에 따라 안전하게 관리되며, 보관 기간 이후 자동 폐기됩니다.",
      },
      {
        id: 36,
        question: "비밀번호가 기억이 안나요.",
        answer:
          "https://weu.kr/forgot-password 휴대폰인증 후 비밀번호 변경 가능합니다.",
      },
      {
        id: 37,
        question: "회원 탈퇴는 어떻게 하나요?",
        answer:
          "고객센터로 1:1 문의를 주시면 회원 탈퇴에서 가능하며, 선정된 캠페인이 종료되지 않은 경우 탈퇴가 제한될 수 있습니다.",
      },
      {
        id: 38,
        question: "탈퇴 후 재 가입도 되나요?",
        answer:
          "탈퇴 후 언제든지 가입은 가능하지만 동일한 이메일 주소로는 재 가입 불가하며, 고객센터로 1:1 문의를 주시면 재 가입이 가능합니다.",
      },
    ],
  },
  {
    type: "기타",
    data: [
      {
        id: 39,
        question: "업체와 연락이 되지 않아요.",
        answer:
          "업체 연락이 어려운 경우, 고객센터 1:1 문의로 양식에 맞춰 문의해 주세요.",
      },
      {
        id: 40,
        question: "FAQ에 없는 내용은 어디에 문의하나요?",
        answer: "카카오톡 채널 또는 고객센터 > 1:1 문의를 이용해 주세요.",
      },
      {
        id: 41,
        question: "리뷰를 삭제하거나 비공개하면 불이익이 있나요?",
        answer:
          "네, 체험단 리뷰는 최소 6개월간 게시 유지가 필수이며,\n무단 삭제 또는 비공개 시 서비스 금액 청구 및 향후 참여 제한 등 페널티가 발생할 수 있습니다.",
      },
    ],
  },
];